var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"rounded px-2 py-1 text-center mx-2",style:(("color: " + (_vm.tag.textColor) + "; background-color: " + (_vm.tag.backgroundColor) + "; font-size: 0.8rem;"))},[_vm._v(" "+_vm._s(_vm.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }